import { render } from "./UsersOverview.vue?vue&type=template&id=184319fd&ts=true"
import script from "./UsersOverview.vue?vue&type=script&lang=ts"
export * from "./UsersOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__